import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { colors } from '../colors';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)' }}>
      <CircularProgress sx={{ color: colors.primaryLight }} />
    </Box>
  );
  return user ? children : <Navigate to="/login" />;
}
